@if(data){
    <jmg-article [data]="data">
        @if(data?.article){
            <div ngSkipHydration [innerHTML]="(data.article?.html ?? '') | sanitizeHtml"></div>
        }
        
    </jmg-article>
}